module Meevo.Plugins.PackageLookup {
    class PackageLookupModalController {

      protected balance: number = 0;
      protected isLookupFailure: boolean = false;
      protected isLookupSuccess: boolean = false;
      protected errorDetail: string;
      protected isThirdPartyGc: boolean = false;
      protected packagesList: any;
      protected expirationDate: Date;
      protected purchasedForClientId: Guid;
      protected purchasedForClientName: string;

      static $inject = [
          "packageNumber",
          "meevo.AppSettings",
          "meevo.components.common.DataService",
          "meevo.components.busy.BusyService",
          "meevo.components.tracking.TrackingService",
          "$mdDialog",
          "$timeout",
          "$rootScope"
        ];

      constructor(protected packageNumber: string,
        protected appSettings: Meevo.Components.Common.IAppSettings,
        protected dataService: Meevo.Components.BaseClasses.IDataService,
        protected busyService: Meevo.Components.Busy.IBusyService,
        protected trackingService: Meevo.Components.Tracking.ITrackingService,
        protected $mdDialog: ng.material.IDialogService,
        protected $timeout: ng.ITimeoutService,
        protected $rootScope: ng.IRootScopeService) {

        let vm = this;
        this.$timeout(() => vm.setFocusOnField(), 1000);
        if (!_.isEmpty(vm.packageNumber)) {
          vm.search();
        }
      }

      setFocusOnField() {
        $("#packageNumber input").focus();
      }

        search(): void {
          if (!_.isEmpty(this.packageNumber)) {
              let item = new Model.TrackingItem(Model.NounEnum.PackageLookup, Model.VerbEnum.SearchButtonClicked, { packageNumber: this.packageNumber }, null);
            this.trackingService.saveTrackingInfo(item);

            this.isLookupSuccess = false;
            this.isLookupFailure = false;
            this.errorDetail = "";
            this.expirationDate = undefined;
            this.packagesList = [];
            this.purchasedForClientId = null;

            let data: any = {
              criteria: {
                packageNumber: this.packageNumber
              },
              pageNumber: 0,
              itemsPerPage: 1000
            };

            this.busyService.start();

            this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.clientPackageHistory, data)
              .then((data: any) => {
                this.packagesList = data;

                if (data.length > 0) {
                  this.isLookupSuccess = true;
                  this.isLookupFailure = false;
                  this.purchasedForClientId = data[0]["purchasedForClientId"];
                  this.purchasedForClientName = data[0]["purchasedForDisplayName"];
                } else {
                  this.isLookupSuccess = false;
                  this.isLookupFailure = true;
                }
              })
              .catch((reason: any) => {
                this.isLookupFailure = true;
                this.isLookupSuccess = false;
              })
              .finally(() => {
                this.busyService.stop();
              });

          }
        }

        isPurchasedForNotAnonymousClient = () => {
          return this.purchasedForClientId && !this.purchasedForClientId.equals(Guid.empty);
        }

        closeModal = () => {
          this.$mdDialog.cancel();
        }

        launchPackageHistory = () => {
          if (!_.isEmpty(this.packageNumber) && this.isLookupSuccess && (this.isPurchasedForNotAnonymousClient())) {
            this.$mdDialog.hide().then((response: any) => {
              this.$rootScope.$broadcast("gotoState", {
                stateName: "client",
                stateParams: {
                  callback: undefined,
                  callbackState: undefined,
                  targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                  actionState: Meevo.Model.MaintenanceFormState.Readonly,
                  id: this.purchasedForClientId,
                  initialEditSection: "SECTION_HISTORY",
                  initialEditSubSection: "PACKAGE_HISTORY",
                  clientDisplayName: this.purchasedForClientName
                }
              });
            });
          }
        }

        goToTransactionEditor = (transactionId: string) => {
          this.$mdDialog.hide().then(() => {
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: {
                    transactionId: transactionId,
                    includeActive: true,
                    includeCompleted: true,
                    includeOnHold: false,
                    includeRefunded: true,
                    includeVoided: true
                },
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
          });
        }
    }

    angular.module("meevo.plugins.packageLookup")
      .controller("meevo.plugins.packageLookup.PackageLookupModalController", PackageLookupModalController);
}